module.exports = __webpack_public_path__ + "static/media/mx1.023d510f.png";